/**
 * Canonical persisted representations of system-dropdown parameter values. Mirrors the backend's
 * `SystemDropdownParameterValues`: parameter values are stored as opaque strings so one table can
 * carry every parameter kind, which means both ends must agree on the encoding.
 *
 * Typed as `string` rather than as an enum on purpose: the values they are compared against arrive
 * from the API as plain strings, and an enum member has no shared enum type with those.
 */
export const SystemDropdownParameterValue: {
  readonly True: string;
  readonly False: string;
  readonly AttendancePresent: string;
  readonly AttendanceAbsent: string;
  readonly IncomeStandard: string;
  readonly IncomeNonSeizable: string;
  readonly IncomeDailyRate: string;
  readonly IncomeSpecialPaymentsExpected: string;
} = {
  True: "true",
  False: "false",
  AttendancePresent: "Present",
  AttendanceAbsent: "Absent",
  IncomeStandard: "Standard",
  IncomeNonSeizable: "NonSeizable",
  IncomeDailyRate: "DailyRate",
  IncomeSpecialPaymentsExpected: "SpecialPaymentsExpected",
};

/** The allowed values of a boolean parameter, in the order they are offered. */
export const BooleanParameterValues: readonly string[] = [
  SystemDropdownParameterValue.True,
  SystemDropdownParameterValue.False,
];
